<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title class="dialog-title">Feedback</h2>
    <button mat-dialog-close matIconButton aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="feedbackForm" (ngSubmit)="submitFeedbackForm()">
    <mat-dialog-content>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Firstname / Lastname</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>E-Mail</mat-label>
        <input matInput formControlName="email" type="email" />
        <ng-container>
          @if (feedbackForm.get('email')?.touched && feedbackForm.get('email')?.invalid) {
            <mat-error>Please enter a valid email address</mat-error>
          }
        </ng-container>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Company</mat-label>
        <input matInput formControlName="company" type="text" />
      </mat-form-field>

      <div class="select-container">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Select feedback type...</mat-label>
          <mat-select formControlName="type">
            @for (issueType of issueTypes; track $index) {
              <mat-option [value]="issueType">
                {{ issueType }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Select feedback level...</mat-label>
          <mat-select formControlName="level">
            @for (issueLevel of issueLevels; track $index) {
              <mat-option [value]="issueLevel">
                {{ issueLevel }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" />
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description"></textarea>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="file-input">
        <mat-label>Optional image</mat-label>
        <button
          matIconButton
          type="button"
          matPrefix
          aria-label="Upload file"
          (click)="hiddenInput.click()"
        >
          <mat-icon>upload_file</mat-icon>
        </button>
        <input
          hidden
          type="file"
          formControlName="file"
          accept="image/*"
          #hiddenInput
          (change)="getFileOnLoad($event)"
        />
        <input
          matInput
          [value]="this.imageToUpload?.name"
          readonly
          disabled
          type="text"
          id="fakeFileInputFeedback"
          (click)="hiddenInput.click()"
        />
      </mat-form-field>

      <div class="row">
        <mat-checkbox formControlName="isAccepted"> </mat-checkbox>
        <div [class.error]="feedbackForm.touched && feedbackForm.get('isAccepted')?.value != true">
          I understand and accept that the information submitted through this form is treated via
          Microsoft Azure and therefore may be shared with third-parties.
        </div>
      </div>

      <div class="row">
        <re-captcha
          siteKey="6Ldb7zcUAAAAADpGmUYGHKDq4HnQ-WqzfqissGje"
          name="captcha"
          (resolved)="onCaptchaResolved($event ?? '')"
          (expired)="onCaptchaExpired()"
        ></re-captcha>
        @if (captchaError) {
          <div class="error">Please complete the captcha.</div>
        }
        @if (formError) {
          <div class="error">Please fill all mandatory fields.</div>
        }
      </div>
    </mat-dialog-content>

    <mat-dialog-actions>
      @if (feedbackLoader) {
        <mat-icon><mat-spinner diameter="20"></mat-spinner></mat-icon>
      }
      <button
        matButton="outlined"
        type="button"
        mat-dialog-close
        class="warn-button"
        [disabled]="feedbackLoader"
      >
        Cancel
      </button>
      <button matButton="filled" type="submit" [disabled]="feedbackLoader">Submit Feedback</button>
    </mat-dialog-actions>
  </form>
</div>
